// src/index.js (Asegúrate de que se vea así)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // o eliminar si no lo usas
import App from './App';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Importa Font Awesome

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);